import React from 'react';

interface SoundToggleProps {
    soundEnabled: boolean;
    onToggle: (enabled: boolean) => void;
}

export const SoundToggle: React.FC<SoundToggleProps> = ({ soundEnabled, onToggle }) => (
    <button
        onClick={() => onToggle(!soundEnabled)}
        style={{
            padding: '12px',
            borderRadius: '50%',
            border: `2px solid ${soundEnabled ? '#10b981' : '#6b7280'}`,
            backgroundColor: soundEnabled ? '#dcfce7' : '#f3f4f6',
            color: soundEnabled ? '#059669' : '#6b7280',
            cursor: 'pointer',
            transition: 'all 0.3s'
        }}
        title={soundEnabled ? 'כבה סאונדים' : 'הפעל סאונדים'}
    >
        <span style={{ fontSize: '24px' }}>
            {soundEnabled ? '🔊' : '🔇'}
        </span>
    </button>
);